import React from 'react';
import './Page.css';
import WorldMapComponent from "../componetns/menu/worldMap/WorldMapComponent";

function WorldMap() {

    return (
        <div className="main_work_field">
            <WorldMapComponent/>
        </div>
    );
}

export default WorldMap;
